module.exports = function () {
    $(document).ready(function () {

	    var helper = require('./../../helper');

        /** TODO: Determine modal where the error has been appeared */
        if ($.find('.has-error').length != 0) {
            $('#add-client-contact').modal('show');
        }

    });
}();
